<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackBar" color="#e7ab5f" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card>
          <v-card-title class="elevation-1">
            About Company
            <v-spacer></v-spacer>
            <!-- <v-flex cols="12" sm="3">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                solo
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex> -->
            <span v-if="!storage">
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="600px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="red" v-bind="attrs" v-on="on">
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider">
                    <v-card-title>
                      <span class="headline">Add About</span>
                    </v-card-title>
                    <v-card-text>
                      <v-layout>
                        <v-flex xs12 md12 lg12>
                          <v-textarea
                            rows="4"
                            outlined
                            v-model="text"
                            label="About Text"
                            :rules="[rules.required]"
                            required
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap>
                        <v-flex xs12 md12 lg12>
                          <v-img
                            v-if="imagePreview"
                            :src="imagePreview"
                            width="400px"
                            height="200px"
                            class="align-center"
                            contain
                          /><br />
                          <v-btn outlined @click="$refs.showImage.click()"
                            >Upload Logo
                            <v-item-group>
                              <input
                                v-show="false"
                                label="Upload Image"
                                ref="showImage"
                                id="file"
                                type="file"
                                style="display: none"
                                @change="showImage"
                              />
                              <!-- </v-file-input> -->
                            </v-item-group>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </span>
          </v-card-title>
          <div v-if="storage">
            <v-container grid-list-md>
              <v-layout wrap pt-10 pb-10 justify-center>
                <v-flex md6 pa-4>
                  <v-card style="line-height: 16px; cursor: pointer" tile flat>
                    <v-img
                      contain
                      :src="baseURL + storage.image"
                      height="300px"
                      cover
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#FF2323"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-layout wrap justify-center px-2>
                      <br />
                      <v-flex px-4 xl12 lg12 md12 sm12 xs12 justify-center>
                        <span style="font-size: 16px; color: #000000; text-align:justify;">
                          {{ storage.text }}
                        </span>
                      </v-flex>
                      <v-flex pt-5 px-4 xl12 sm12 xs12 lg12 m12 justify-center>
                        <v-dialog v-model="editdialog" max-width="600px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              class="mr-2"
                              outlined
                              v-on="on"
                              v-bind="attrs"
                              color="red"
                            >
                              Edit
                            </v-btn>
                          </template>
                          <v-card>
                            <v-form v-model="addslider">
                              <v-card-title>
                                <span class="headline">Edit About</span>
                              </v-card-title>
                              <v-card-text>
                                <v-layout>
                                  <v-flex xs12 md12 lg12>
                                    <v-textarea
                                      rows="4"
                                      outlined
                                      v-model="text"
                                      label="About Text"
                                      :rules="[rules.required]"
                                      required
                                    ></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                  <v-flex xs12 md12 lg12>
                                    <v-img
                                      v-if="storage.image && !imagePreview"
                                      :src="file"
                                      width="400px"
                                      height="200px"
                                      class="align-center"
                                      contain
                                    /><br />
                                    <v-img
                                      v-if="imagePreview"
                                      :src="imagePreview"
                                      width="400px"
                                      height="200px"
                                      class="align-center"
                                      contain
                                    /><br />
                                    <v-btn
                                      outlined
                                      @click="$refs.showImage.click()"
                                      >Upload Logo
                                      <v-item-group>
                                        <input
                                          v-show="false"
                                          label="Upload Image"
                                          ref="showImage"
                                          id="file"
                                          type="file"
                                          style="display: none"
                                          @change="showImage"
                                        />
                                        <!-- </v-file-input> -->
                                      </v-item-group>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="editdialog=false"
                                >
                                  Close
                                </v-btn>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  :disabled="!addslider"
                                  @click="add()"
                                >
                                  Save
                                </v-btn>
                              </v-card-actions>
                            </v-form>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                      <br />
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <div v-else>
            <v-layout justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span
                  style="
                    font-size: 22px;
                    font-family: poppinssemibold;
                    letter-spacing: 1px;
                  "
                >
                  No slider Found...
                  <br />
                  Try adding Slider
                </span>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      file: null,
      showPreview: false,
      imagePreview: null,

      msg: null,
      showSnackBar: false,
      timeout: 5000,
      appLoading: false,

      pages: 0,
      widthOfCard: "250px",
      text: null,
      heading: null,

      dialogDelete: false,
      search: "",
      ratings: [],
      dialog: false,
      editdialog:false,
      ServerError: false,
      storage: {
        file: null,
        text: null,
      },
      addslider: false,
      imgId: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/homepage/view",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.storage = response.data.data.about;
            this.file = this.baseURL + this.storage.image;
            this.text = this.storage.text;
          } else {
            this.appLoading = false;
            // this.storage = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    dialogclose() {
      this.sliderText = null;
      this.dialog = false;
    },

    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      this.showPreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    add() {
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("text", this.text);

      axios({
        method: "POST",
        url: "/homepage/about/add/update",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
            this.editdialog = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>